import React from "react";
import MolGrid from "../../../components/Grid/MolGrid";
import ViewCommitteeBatchApprovalList from "../../../features/CommitteeApproval/components/ViewCommitteeBatchApprovalList";

const ViewCommitteeBatchApproval = () => {
  return (
    <>
    <ViewCommitteeBatchApprovalList/>
    </>
  );
};

export default ViewCommitteeBatchApproval;
